import React, { useState } from "react";
import { Stepper, Step, StepLabel, Button, Box, Typography } from "@mui/material";
import QontoConnector from "./QontoConnector";
import PersonalDetails from "./PersonalDetails";
import BusinessDetails from "./BusinessDetails";
import BankDetails from "./BankDetails";
import Verification from "./Verification";
import AdditionalInfo from "./AdditionalInfo";
import { CheckCircle, Business, AccountBalance, VerifiedUser, Settings } from "@mui/icons-material";

const steps = [
    { label: "Personal Details", icon: <CheckCircle /> },
    { label: "Business Details", icon: <Business /> },
    { label: "Bank Details", icon: <AccountBalance /> },
    { label: "Verification", icon: <VerifiedUser /> },
    { label: "Additional Information", icon: <Settings /> },
];
const MerchantStepper = () => {
    const [activeStep, setActiveStep] = useState(0);
    const [formData, setFormData] = useState({
        firstName: "",
        middleName: "",
        lastName: "",
        merchantPhoneNumber: "",
        merchantEmailId: "",
        companyLegalName: "",
        gstinNumber: "",
        merchantAddress1: "",
        merchantState: 0,
        merchantCityName: "",
        merchantDistrictName: "",
        merchantPinCode: "",
        merchantCompanyBankAccountNumber: "",
        merchantBankIfscCode: "",
        merchantBankAccountName: "",
        certificateOfIncorporationImage: false,
        tradeBusinessProof: false,
        termsConditionCheck: false,
        cancelledChequeImages: false,
        physicalVerification: false,
        videoKycWithLatLongData: false,
        userPan: "",
        aadhaarNumber: "",
        companyOrShopPan: false,
        shopAddress: "",
        shopCity: "",
        shopDistrict: "",
        shopState: 0,
        shopPincode: "",
        shopLatitude: "",
        shopLongitude: "",
        backgroundImageOfShop: false,
        shopAndPanImage: false,
        username: "",
        password: "",
        companyType: "",
    });

    const handleNext = (values) => {
        setFormData((prevData) => ({ ...prevData, ...values })); // Merge new data
        setActiveStep((prevStep) => prevStep + 1);
    };

    const handleBack = () => setActiveStep((prevStep) => prevStep - 1);

    const handleFinalSubmit = (values) => {
        const finalData = { ...formData, ...values };
        console.log("Final Submission:", finalData);
        // Make API Call here with finalData
    };

    const stepComponents = [
        <PersonalDetails initialValues={formData} onNext={handleNext} />,
        <BusinessDetails initialValues={formData} onNext={handleNext} onBack={handleBack} />,
        <BankDetails initialValues={formData} onNext={handleNext} onBack={handleBack} />,
        <Verification initialValues={formData} onNext={handleNext} onBack={handleBack} />,
        <AdditionalInfo initialValues={formData} onSubmit={handleFinalSubmit} onBack={handleBack} />,
    ];
    const CustomStepIcon = ({ icon, active, completed }) => {
        const iconStyles = {
            fontSize: "0.1rem",  // Larger icon size
            backgroundColor: active ? "#f4a300" : completed ? "#4caf50" : "#eaeaf0",  // Green for active, Yellow for completed, Gray for default
            color: "#fff",
            borderRadius: "50%",
            padding: "12px",
            transition: "background-color 0.3s ease, transform 0.3s ease",
            boxShadow: active ? "0px 4px 8px rgba(0, 0, 0, 0.2)" : "none",  // Shadow for active state
            transform: active ? "scale(1.2)" : "scale(1)",  // Slightly scale up when active
        };

        return <Box sx={iconStyles}>{icon}</Box>;
    };
    return (
        <Box p={4} mt={8}>
            <Typography variant="h4" align="center" gutterBottom>Merchant Registration</Typography>
            <Stepper activeStep={activeStep} alternativeLabel connector={<QontoConnector />}>
                {steps.map((step, index) => (
                    <Step key={step.label}>
                        <StepLabel
                            StepIconComponent={(props) => (
                                <CustomStepIcon {...props} icon={steps[index].icon} />
                            )}
                        >
                            {step.label}
                        </StepLabel>
                    </Step>
                ))}

            </Stepper>
            <Box mt={2}>{stepComponents[activeStep]}</Box>
        </Box>
    );
};

export default MerchantStepper;
